import { render, staticRenderFns } from "./Protokoll.vue?vue&type=template&id=75400316"
import script from "./Protokoll.vue?vue&type=script&lang=js"
export * from "./Protokoll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports